import { render, staticRenderFns } from "./application-card.vue?vue&type=template&id=5fe67967&scoped=true"
import script from "./application-card.vue?vue&type=script&lang=js"
export * from "./application-card.vue?vue&type=script&lang=js"
import style0 from "./application-card.vue?vue&type=style&index=0&id=5fe67967&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe67967",
  null
  
)

export default component.exports